import { isProdEnv, isTestOrStageEnv } from 'utils/isDevEnv';

/** Get the upper public domain based on the current environment */
const getUpperDomain = () => {
  if (isProdEnv()) {
    return '.zaplo.cz';
  }
  if (isTestOrStageEnv()) {
    return '.4finance.com';
  }
  return;
};

export default getUpperDomain;
